import { Link } from "react-router-dom";
import React from "react";

export default function Organisations() {
  const check: any = <i className="bi bi-check beart-icon1"></i>;
  return (
    <div id="szervezet">
      <div className="mt-8 border-2 border-green-600 p-4">
        <div className="beart-title">
          Szervezetek számára ajánlott programok
        </div>
        <div className="beart-subtitle flex">
          <i className="bi bi-card-checklist mr-2 text-2xl"></i>
          <div className="my-1">
            Kiégés megelőzés művészetterápiás gyakorlatokkal program
          </div>
        </div>
        <p>
          A munkahelyi mentálhigiénés megelőző és stresszkezelés programok
          hatékony eszközeként, segít a kiégési szakaszok felismerésében és
          visszafordításában, csoportosan és egyénileg is használható, elméleti
          résszel kiegészítve. Számos kreatív és relaxációs technikával, amelyek
          elvégzése már magukban stresszoldó hatásúak.
        </p>

        <div className="beart-title">
          Miért ajánlom a szervezeteknek a kiégés prevenciós programot?
        </div>
        <ul className="list-outsidemb-8">
          <li className="mb-2 flex">
            {check}
            <div>nő a résztvevők önreflexiós készsége</div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>új tapasztalatot szerezhetnek,</div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>új, színes, kreatív gyakorlatokat ismerhetnek meg,</div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>az önkifejezés lehetőségét adja,</div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>fejleszti a kommunikációt,</div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>
              az alkotás folyamatában megtapasztalhatják a flow élményét,
            </div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>sikerélményt ad,</div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>
              egyéni fejlesztési folyamatokban és csoportos fejlesztések során
              is alkalmazható,
            </div>
          </li>
          <li className="mb-2 flex">
            {check}
            <div>
              ami még fontos, semmilyen előzetes rajztudás nem szükséges a
              programon való részvételhez!
            </div>
          </li>
        </ul>

        <Link to="/kapcsolat" className="w-full">
          <div className="mt-8 rounded-3xl bg-green-700 bg-opacity-25 p-4 text-black transition-colors duration-300 ease-in-out hover:bg-red-700 hover:text-white">
            <div className="mx-auto flex w-full animate-jump-in justify-center text-center text-2xl font-bold">
              <div>Jelentkezés</div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
